import { render, staticRenderFns } from "./PriceSurchargeModal.vue?vue&type=template&id=3babfce7&scoped=true&"
import script from "./PriceSurchargeModal.vue?vue&type=script&lang=ts&"
export * from "./PriceSurchargeModal.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSurchargeModal.vue?vue&type=style&index=0&id=3babfce7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babfce7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
